import { useMutation } from '@tanstack/react-query';
import { purchaseCredits } from './puchaseCredits';
import { globalErrorResponse } from '../../../shared/notification/actions';
import { useTranslation } from 'react-i18next';
import { showNotification } from '../../../shared/notification/toastNotification';

export const usePurchaseCredits = () => {
    const { t } = useTranslation();
    return useMutation(purchaseCredits, {
        onSuccess: () => {
            showNotification(t('notifications.usePurchaseCredits.success'));
        },
        onError: () => {
            globalErrorResponse(t('notifications.usePurchaseCredits.error'));
        }
    });
};
